import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SituacaoContaEnum } from '../../../../shared/enums/SituacaoConta.enum';
import { ContaService } from '../../../../shared/services/conta/conta.service';
import { ClientNotificationService } from '../../../../shared/services/client-notification/client-notification.service';
import { TokenService } from '../../../../shared/services/token/token.service';

declare function unescape(s: string): string;

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.scss']
})
export class PosComponent implements OnInit, OnDestroy {

  public sales: any;
  public tokenId: string;
  public token: any;
  public validationResultError: any;
  public client: string;
  public accountId: string;
  public account: any;
  public profilePicture: string;
  public bloqueio: boolean;
  public showModal: boolean;
  public msgBlock: string;
  public accountNotAllowed: boolean;
  public origemActuar: string;
  public loading = true;
  public isCobrancaAberta = false;
  public isCobrancaProcessada = false;
  public isCobrancaComProblema = false;
  public paymentData: any;
  public statusTitle = '';
  public statusDescription = '';

  private notificationSubscription: Subscription;
  private paymentIdentifiers: string[] = [];

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private route: ActivatedRoute,
    private contaService: ContaService,
    private clientNotificationService: ClientNotificationService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.tokenId = param['tokenId'];
      if (this.getURLParameters('backUrl')) {
        this.origemActuar = this.getURLParameters('backUrl');
      }
      this.getToken();
    });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  getToken() {
    if (!this.tokenId) {
      this.router.navigate(['/checkout/404']);
      return;
    }

    this.loading = true;
    this.tokenService.obterToken(this.tokenId).subscribe((data: any) => {
      this.validationResultError = data &&
        data.Validacao &&
        data.Validacao.Erros &&
        data.Validacao.Erros.length > 0 ?
        data.Validacao.Erros[0] :
        null;

      this.getAccount(data.ContaId);

      this.token = data;
      this.sales = this.sortSales(data.Vendas);
      this.paymentData = data.Vendas[0];
      this.paymentIdentifiers = this.extractPaymentIdentifiers(this.paymentData);

      this.accountId = data.ContaId;
      this.client = data.Vendas && data.Vendas[0] ? data.Vendas[0].Cliente : null;
      console.log('teste')
      this.applyPaymentStatus(this.paymentData);
      this.updateStatusMessages();

      if (this.validationResultError) {
        this.loading = false;
        return;
      }

      this.loading = false;

      if (this.isCobrancaAberta && !this.isCobrancaComProblema && data.ContaId) {
        this.verificarSePagamentoFoiProcessado(data.ContaId);
      }
    }, (err) => {
      console.error(err);
      this.router.navigate(['/checkout/404']);
    });
  }

  getAccount(contaId) {
    if (!contaId) {
      return;
    }

    this.contaService.obterConta(contaId).subscribe((data: any) => {
      this.account = data;

      if (this.account && this.account.Objetos && this.account.Objetos.length > 0) {
        this.account.Objetos.forEach((objeto) => {
          if (objeto.TipoObjeto === 3) {
            this.profilePicture = 'https://' + objeto.CaminhoObjeto;
          }
        });
      }

      if (this.account && this.account.Situacao == SituacaoContaEnum.Bloqueada) {
        this.bloqueio = true;
      }

      if (data && data.TipoCadastro === 'PagueLa') {
        this.checkAccount();
      }
    }, (err) => {
      console.error(err);
    });
  }

  sortSales(sales) {
    if (!sales) {
      return [];
    }

    let parceladas = sales.filter((sale) => sale.Parcelas !== null);
    let recorrentes = sales.filter((sale) => sale.Recorrencia);

    recorrentes = recorrentes.sort(function(a, b) {
      if (
        b.Recorrencia &&
        !b.Recorrencia.QuantidadeRecorrencia
      ) { return 1; }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia > b.Recorrencia.QuantidadeRecorrencia
      ) {
        return 1;
      }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia < b.Recorrencia.QuantidadeRecorrencia
      ) { return -1; }

      return 0;
    });

    parceladas = parceladas.sort(function(a, b) {
      if (a.Parcelas > b.Parcelas) { return 1; }
      if (a.Parcelas < b.Parcelas) { return -1; }
      return 0;
    });

    return sales;
  }

  checkAccount() {
    if (!this.account) {
      return;
    }

    let isIncomplete = false;

    if (
      (this.account.TipoConta && this.account.TipoConta === 'Fisica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
        !this.account.Nome || this.account.Nome.length === 0 ||
        !this.account.Sobrenome || this.account.Sobrenome.length === 0)
    ) {
      isIncomplete = true;
    }

    if (
      (this.account.TipoConta && this.account.TipoConta === 'Juridica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
        !this.account.RazaoSocial || this.account.RazaoSocial.length === 0 ||
        !this.account.Fantasia || this.account.Fantasia.length === 0 ||
        !this.account.Nome || this.account.Nome.length === 0)
    ) {
      isIncomplete = true;
    }

    if (
      !this.account.Enderecos || this.account.Enderecos.length === 0 ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cep || this.account.Enderecos[0].Cep.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Logradouro || this.account.Enderecos[0].Logradouro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Numero || this.account.Enderecos[0].Numero.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Bairro || this.account.Enderecos[0].Bairro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cidade || this.account.Enderecos[0].Cidade.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Estado || this.account.Enderecos[0].Estado.length === 0)
    ) {
      isIncomplete = true;
    }

    if (
      !this.account.InformacoesBancarias || this.account.InformacoesBancarias.length === 0 ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Banco || this.account.InformacoesBancarias[0].Banco.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Agencia || this.account.InformacoesBancarias[0].Agencia.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].NumeroConta || this.account.InformacoesBancarias[0].NumeroConta.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].ContaDigito || this.account.InformacoesBancarias[0].ContaDigito.length === 0)
    ) {
      isIncomplete = true;
    }

    if (this.account && this.account.Situacao != SituacaoContaEnum.Ativa) {
      this.openModal('O seu cadastro está pendente de aprovação.');
      return;
    }

    if (isIncomplete === true) {
      this.openModal('Os dados da sua conta estão incompletos. Faça o login e preencha os dados que estão faltando.');
      return;
    }
  }

  openModal(msg) {
    this.showModal = true;
    this.msgBlock = msg;
  }

  closeModal() {
    this.showModal = false;
    this.msgBlock = '';
  }

  verificarSePagamentoFoiProcessado(contaId: string) {
    if (!contaId) {
      return;
    }

    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }

    this.notificationSubscription = this.clientNotificationService.openConnection(['onPixNotification'], contaId).subscribe((data) => {
      const pixEvent = data && data.eventData ? data.eventData.Pix : null;
      if (!pixEvent || !this.paymentIdentifiers || this.paymentIdentifiers.length === 0) {
        return;
      }

      const eventIdentifiers = this.extractEventIdentifiers(pixEvent);
      const hasMatch = eventIdentifiers.some((eventId) => this.paymentIdentifiers.indexOf(eventId) !== -1);

      if (hasMatch) {
        this.isCobrancaAberta = false;
        this.isCobrancaProcessada = true;
        this.isCobrancaComProblema = false;
        this.updateStatusMessages();

        if (this.origemActuar) {
          setTimeout(() => {
            window.location.href = `${this.origemActuar}?action=CR`;
          }, 5000);
        }
      }
    });
  }

  getURLParameters(paramName) {
    const sURL = window.document.URL.toString();
    if (sURL.indexOf('?') > 0) {
      const arrParams = sURL.split('?');
      const arrURLParams = arrParams[1].split('&');
      const arrParamNames = new Array(arrURLParams.length);
      const arrParamValues = new Array(arrURLParams.length);

      let i = 0;
      for (i = 0; i < arrURLParams.length; i++) {
        const sParam =  arrURLParams[i].split('=');
        arrParamNames[i] = sParam[0];
        if (sParam[1] !== '') {
          arrParamValues[i] = unescape(sParam[1]);
        } else {
          arrParamValues[i] = null;
        }
      }

      for (i = 0; i < arrURLParams.length; i++) {
        if (arrParamNames[i] === paramName) {
          return arrParamValues[i];
        }
      }
      return null;
    }
  }

  private applyPaymentStatus(payment: any) {
    this.isCobrancaAberta = false;
    this.isCobrancaProcessada = false;
    this.isCobrancaComProblema = false;
    console.log(payment);
    if (!payment) {
      return;
    }

    const situacao = payment.Situacao || payment.Status || '';
    console.log(situacao);
    const normalizedSituacao = (situacao || '').toString().toUpperCase();

    const openSituations = ['ABERTA', 'ABERTO', 'PENDENTE', 'AGUARDANDO_PAGAMENTO'];
    const processedSituations = ['CONCLUIDA', 'CONCLUIDO', 'RECEBIDO', 'PAGO', 'PAGA', 'APROVADO', 'APROVADA', 'LIQUIDADO', 'LIQUIDADA', 'FINALIZADO'];
    const problemSituations = ['NAO_REALIZADO', 'DEVOLVIDO', 'REMOVIDA_PELO_USUARIO_RECEBEDOR', 'REMOVIDA_PELO_PSP', 'CANCELADA', 'CANCELADO', 'NEGADA', 'RECUSADO', 'FALHA', 'ERRO'];

    if (problemSituations.indexOf(normalizedSituacao) !== -1) {
      this.isCobrancaComProblema = true;
      return;
    }

    if (processedSituations.indexOf(normalizedSituacao) !== -1) {
      this.isCobrancaProcessada = true;
      return;
    }

    if (openSituations.indexOf(normalizedSituacao) !== -1 || !normalizedSituacao) {
      this.isCobrancaAberta = true;
    }
  }

  private updateStatusMessages() {
    if (this.isCobrancaComProblema) {
      this.statusTitle = 'Não foi possível confirmar o pagamento';
      this.statusDescription = 'Entre em contato com o estabelecimento para verificar o status da cobrança na maquininha.';
      return;
    }

    if (!this.isCobrancaAberta && this.isCobrancaProcessada) {
      this.statusTitle = 'Pagamento aprovado!';
      this.statusDescription = 'Recebemos a confirmação da maquininha. Você já pode prosseguir com o atendimento.';
      return;
    }

    this.statusTitle = 'Aguardando pagamento na maquininha';
    this.statusDescription = 'Assim que a transação for concluída na maquininha, atualizaremos automaticamente esta tela.';
  }

  private extractPaymentIdentifiers(payment: any): string[] {
    if (!payment) {
      return [];
    }

    const identifiers = [
      payment.CobrancaPixId,
      payment.BoletoId,
      payment.CobrancaId,
      payment.TransacaoId,
      payment.TransacaoPosId,
      payment.TransacaoMaquininhaId,
      payment.Id,
      payment.ID,
      payment.TokenId
    ];

    return identifiers
      .filter((value) => value !== undefined && value !== null)
      .map((value) => value.toString());
  }

  private extractEventIdentifiers(eventData: any): string[] {
    if (!eventData) {
      return [];
    }

    const identifiers = [
      eventData.cobrancaPixId,
      eventData.cobrancaId,
      eventData.boletoId,
      eventData.transacaoId,
      eventData.transacaoPosId,
      eventData.id
    ];

    return identifiers
      .filter((value) => value !== undefined && value !== null)
      .map((value) => value.toString());
  }
}
